/**
 * priceParams — Envío 4: filtra el `data` de un nodo a las claves que pueden
 * definir precio (duración, resolución, modo, texto…). Las salidas y el
 * estado interno NO se mandan a /credits/quote (evita cotizaciones de más).
 */
const NON_PRICE_KEYS = new Set([
  'outputUrl', 'output_url', 'outputAssetId', 'status', 'error',
  'executionId', 'progress',
]);

export const priceParams = (data) => {
  const out = {};
  for (const [k, v] of Object.entries(data || {})) {
    if (k.startsWith('__') || NON_PRICE_KEYS.has(k)) continue;
    if (v === null || v === undefined || v === '') continue;
    if (typeof v === 'object') continue;           // archivos/referencias crudas
    out[k] = v;
  }
  return out;
};
